<template>
  <b-container fluid>
    <b-button variant="success" class="my-3" @click="createNews({method:'create'})">Создать запись</b-button>
    <b-table :fields="fields"
             :items="categories"
             show-empty
             responsive
             id="mytable"
             :sort-by.sync="sortBy"
             :sort-desc.sync="sortDesc"
             :sort-direction="sortDirection"
             :sort-compare="sortCompare"
    >
      <template v-slot:cell(client_type)="row">
        <div>{{ getClientNames(row.item.client_type) }}</div>
        <div>{{ getServerNames(row.item.server_type) }}</div>
      </template>
      <template v-slot:cell(actions)="row">
        <b-button size="sm" variant="warning" class="mr-1" @click="editNews({method:'edit',item:row.item})">
          <i class="fas fa-pen"></i>
        </b-button>
        <b-button as="a" size="sm" variant="success" class="mr-1" target="_blank" :href="recordLink(row.item)">
          <i class="fas fa-external-link-alt"></i>
        </b-button>
        <!--<b-button size="sm" variant="danger" class="mr-1" @click="deleteNews(row.item)">-->
        <!--<i class="fas fa-trash-alt"></i>-->
        <!--</b-button>-->
      </template>
      <template v-slot:cell(is_published)="row">
        <i v-if="row.value" class="fas fa-check"></i>
        <i v-else class="fas fa-times"></i>
      </template>
      <template v-slot:cell(publication_date)="row">
        <p v-if="row.item.publication_date!==null">{{ new Date(row.value).toLocaleString('ru')}}</p>
        <p v-else>{{row.item.publication_date}}</p>
      </template>
    </b-table>
    <b-row class="mx-0">
      <b-modal
        id="newsModal"
        ref="modal"
        title="Создание записи"
        size="lg"
        @ok="sendModalData($event)"
        @hidden="clearModal"
        ok-title="Отправить" ok-variant="success"
        cancel-variant="danger" cancel-title="Отменить"
        :no-close-on-backdrop=true
        :ok-disabled="veeErrors.any()"
      >
        <b-form ref="form" @submit.stop.prevent="sendModalData">
          <!--<b-alert show variant="danger" v-if="showAlert">Такой ЧПУ уже существует</b-alert>-->
          <b-form-group id="title"
                        label="Заголовок *:"
                        label-for="title"
                        :invalid-feedback="getError('title')">
            <b-form-input
              id="title"
              name="title"
              v-model="form.title"
              required
              placeholder="Введите заголовок"
              @blur="createSlug"
              data-vv-as="заголовок"
              v-validate="{required:true}"
              :state="validateState('title')"
            ></b-form-input>
          </b-form-group>
          <b-row>
            <b-col md="2">
              <b-form-group label="Опубликовать:">
                <b-form-checkbox
                  id="published"
                  v-model="form.is_published"
                ></b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col md="5">
              <b-form-group id="category"
                            label="Тип *:"
                            label-for="category"
                            :invalid-feedback="getError('category')">
                <b-form-select
                  id="category"
                  name="category"
                  v-model="form.type"
                  :options="categoryTypes"
                  text-field="name"
                  value-field="name"
                  data-vv-as="Тип"
                  @change="selectedType($event)"
                  v-validate="{required:true}"
                  :state="validateState('category')"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="5">
              <b-form-group id="robots" label="Robots:" label-for="robots">
                <b-form-select
                  id="robots"
                  v-model="form.robots"
                  :options="robots"
                  text-field="content"
                  value-field="id"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="form.type === 'Новости для Fill-Bill клиента'">
            <b-col md="6">
              <b-form-group id="clientType"
                            label="Тип клиента:"
                            label-for="clientType"
                            :invalid-feedback="getError('clientType')">
                <b-form-select
                  id="clientType"
                  name="clientType"
                  v-model="form.client_type"
                  :options="clientTypes"
                  text-field="name"
                  value-field="id"
                  data-vv-as="Тип клиента"
                  v-validate="{required:true}"
                  :state="validateState('clientType')"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group id="serverType"
                            label="Тип сервера:"
                            label-for="serverType"
                            :invalid-feedback="getError('serverType')">
                <b-form-select
                  id="serverType"
                  name="serverType"
                  multiple
                  v-model="form.server_type"
                  :options="serverTypes"
                  text-field="name"
                  value-field="id"
                  data-vv-as="Тип сервера"
                  v-validate="{required:true}"
                  :state="validateState('serverType')"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-group id="slug" label="ЧПУ:" label-for="slug">
            <b-form-input
              id="slug"
              v-model="form.slug"
              required
              placeholder="Введите ЧПУ:"
            ></b-form-input>
          </b-form-group>
          <b-form-group id="description" label="Meta-description:" label-for="description">
            <b-form-textarea
              id="description"
              v-model="form.description"
              required
              placeholder="Введите meta-description:"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group id="keywords" label="Meta-keywords:" label-for="keywords">
            <b-form-textarea
              id="keywords"
              v-model="form.keywords"
              required
              placeholder="Введите meta-keywords:"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group id="preview"
                        label="Краткое описание *:"
                        label-for="preview"
                        :invalid-feedback="getError('preview')">
            <b-form-input
              id="preview"
              name="preview"
              v-model="form.preview"
              data-vv-as="Краткое описание"
              v-validate="{required:true}"
              :state="validateState('preview')"
              placeholder="Введите превью новости:"
            ></b-form-input>
          </b-form-group>
          <b-form-group :invalid-feedback="getError('content')"
                        :state="validateState('content')"
          >
            <vue-editor v-model="form.content"
                        :show-preview="true"
                        name="content"
                        v-validate="{required:true}"
                        :state="validateState('content')"
            />
            <b-form-textarea id="code-editor" :key="index" v-html="form.content"
                             @change="updateContent"></b-form-textarea>
          </b-form-group>
        </b-form>
      </b-modal>
    </b-row>
  </b-container>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'fill-bill-news',
  components: {
    VueEditor
  },
  data () {
    return {
      sendMethod: null,
      id: null,
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: true
        },
        {
          key: 'title',
          label: 'Заголовок',
          sortable: false
        },
        {
          key: 'client_type',
          label: 'Тип клиента, сервер',
          sortable: false
        },
        {
          key: 'is_published',
          label: 'Опубликовано',
          sortable: false
        },
        {
          key: 'type',
          label: 'Тип',
          sortable: false
        },
        {
          key: 'publication_date',
          label: 'Дата публикации',
          sortable: false
        },
        {
          key: 'actions',
          label: 'Действия',
          sortable: false
        }
      ],
      form: {
        title: null,
        preview: null,
        content: null,
        is_published: false,
        type: null,
        robots: null,
        description: null,
        keywords: null,
        slug: null,
        server_type: [],
        client_type: null
      },
      clientTypes: [
        { id: 1, name: 'Fill-Bill Main' },
        { id: 2, name: 'Fill-Bill Air' },
        { id: 3, name: 'Fill-Bill Sea' },
        { id: 4, name: 'Fill-Bill Otvt' }
      ],
      selectedTypeName: null,
      showAlert: null,
      index: 0,
      sortBy: 'id',
      sortDesc: false,
      sortDirection: 'asc'
    }
  },
  watch: {
    robots () {
      this.form.robots = this.robots[0].id
    },
    'form.content' (to) {
      this.form.content = to
      this.index++
    }
  },
  computed: {
    ...mapState(
      {
        categories: state => state.fbNews.categoriesList,
        categoryTypes: state => state.fbNews.categoryTypes,
        robots: state => state.fbNews.robots,
        serverTypes: state => state.fbNews.serverTypes
      }
    )
  },
  mounted () {
    this.categoriesList()
    this.loadCategoryTypes()
    this.loadRobots()
    this.getServerTypes()
  },
  methods: {
    getClientNames (id) {
      switch (id) {
        case 1:
          return 'Fill-Bill Main'
        case 2:
          return 'Fill-Bill Air'
        case 3:
          return 'Fill-Bill Sea'
        case 4:
          return 'Fill-Bill Otvt'
      }
    },
    getServerNames (servers) {
      const types = []
      if (servers) {
        servers.map((server) => {
          types.push(this.serverTypes[(parseInt(server) - 1)].name)
          console.log(server)
        })
      }
      return types.join(', ')
      // console.log(this.serverTypes)
    },
    sortCompare (aRow, bRow, key) {
      const a = aRow[key]
      const b = bRow[key]
      if (key === 'id') {
        return a < b ? 1 : a > b ? -1 : 0
      }
    },
    updateContent (value) {
      this.form.content = value
    },
    recordLink (item) {
      let type
      if (item.type === 'Новости') {
        type = 'news'
      } else if (item.type === 'Новости для Fill-Bill клиента') {
        type = 'fb-news'
      } else {
        type = 'manuals'
      }
      return `${location.origin}/categories/${type}/${item.slug}/`
    },
    selectedType (type) {
      this.selectedTypeName = type
    },
    createNews (news) {
      this.sendMethod = news.method
      this.form.robots = this.robots[0].id
      this.$root.$emit('bv::show::modal', 'newsModal', event)
    },
    editNews (news) {
      this.sendMethod = news.method
      this.id = news.item.id
      this.form.title = news.item.title
      this.form.preview = news.item.preview
      this.form.content = news.item.content
      this.form.is_published = news.item.is_published
      this.form.type = news.item.type
      this.form.robots = news.item.robots
      this.form.description = news.item.description
      this.form.keywords = news.item.keywords
      this.form.slug = news.item.slug
      this.form.client_type = news.item.client_type
      this.form.server_type = news.item.server_type
      this.$root.$emit('bv::show::modal', 'newsModal', event)
    },
    deleteNews (news) {
      this.deleteFillBillCategory(news.id)
    },
    checkSlug () {
      if (this.categories.filter(item => item.slug === this.form.slug && item.type === this.selectedTypeName).length > 0) {
        this.showAlert = true
        return false
      } else {
        this.showAlert = false
        return true
      }
    },
    sendModalData (event) {
      // this.checkSlug()
      event.preventDefault()
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return
        }
        this.sendLogic()
        /* this.$nextTick(() => {
          this.$refs.modal.hide()
        }) */
      })
    },
    sendLogic () {
      console.log(this.form)
      if (this.sendMethod === 'create') {
        this.createFillBillCategory(this.form).then(
          () => {
            this.$nextTick(() => {
              this.$refs.modal.hide()
              // this.clearModal()
            })
          },
          error => {
            console.log(error)
          }
        )
      } else if (this.sendMethod === 'edit') {
        this.editFillBillCategory({ id: this.id, form: this.form }).then(
          () => {
            this.$nextTick(() => {
              this.$refs.modal.hide()
              // this.clearModal()
            })
          },
          error => {
            console.log(error)
          }
        )
      }
    },
    clearModal () {
      for (const key in this.form) {
        this.form[key] = null
      }
      this.is_published = false
    },
    createSlug () {
      const a = {
        Ё: 'yo',
        Й: 'i',
        Ц: 'ts',
        У: 'u',
        К: 'k',
        Е: 'e',
        Н: 'n',
        Г: 'g',
        Ш: 'sh',
        Щ: 'sch',
        З: 'z',
        Х: 'h',
        Ъ: '',
        ё: 'yo',
        й: 'i',
        ц: 'ts',
        у: 'u',
        к: 'k',
        е: 'e',
        н: 'n',
        г: 'g',
        ш: 'sh',
        щ: 'sch',
        з: 'z',
        х: 'h',
        ъ: '',
        Ф: 'f',
        Ы: 'i',
        В: 'v',
        А: 'a',
        П: 'p',
        Р: 'r',
        О: 'o',
        Л: 'l',
        Д: 'd',
        Ж: 'zh',
        Э: 'e',
        ф: 'f',
        ы: 'i',
        в: 'v',
        а: 'a',
        п: 'p',
        р: 'r',
        о: 'o',
        л: 'l',
        д: 'd',
        ж: 'zh',
        э: 'e',
        Я: 'ya',
        Ч: 'ch',
        С: 's',
        М: 'm',
        И: 'i',
        Т: 't',
        Ь: '',
        Б: 'b',
        Ю: 'yu',
        я: 'ya',
        ч: 'ch',
        с: 's',
        м: 'm',
        и: 'i',
        т: 't',
        ь: '',
        б: 'b',
        ю: 'yu',
        ' ': '-',
        ',': '',
        '.': '',
        '?': '',
        '!': '',
        '%': '',
        '@': '',
        '*': '',
        '#': '',
        $: ''
      }

      this.form.slug = this.form.title.split('').map(function (char) {
        return a[char] || ''
      }).join('')
    },
    getError (ref) {
      return this.veeErrors.first(ref)
    },
    validateState (ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref)
      }
      return null
    },
    ...mapActions('fbNews', [
      'createFillBillCategory',
      'editFillBillCategory',
      'deleteFillBillCategory',
      'categoriesList',
      'loadRobots',
      'loadCategoryTypes',
      'getServerTypes'
    ])
  }
}
</script>

<style scoped>
  .fa-check {
    color: #40b539;
  }

  .fa-times {
    color: #e7161a;
  }

  #code-editor {
    width: 100%;
    margin-top: 10px;
    min-height: 200px;
  }
</style>
